import {BaseApiTemplateService, Core2Config} from "../../shared";
import {WfProjectIssueTypeContainerModel} from "../../../../../../models/aggregates/wf/project/wf-project-issue-type-container.model";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class WfProjectIssueTypeService extends BaseApiTemplateService<WfProjectIssueTypeContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-issue-type-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-issue-type-links';
    this.httpClient = http;
  }
}
